export default "__VITE_ASSET__CCixkMuO__"